import React from 'react';
import styles from './ConfirmationPage.module.css'; // Importando o arquivo de estilos
import { Link } from 'react-router-dom'; // Para o redirecionamento do botão

const ConfirmationPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.cardConfirmacao}>
        <h2>
        <i className="fas fa-check-circle"></i>
          Inscrição Confirmada!
        </h2>
        <p>Agora você está oficialmente na nossa lista de espera para o próximo lançamento!</p>
        <p>Todas as informações importantes serão enviadas diretamente para o seu e-mail.</p>
        <p><strong>Se não encontrar nosso e-mail na caixa de entrada, verifique sua caixa de spam ou a aba de promoções.</strong></p>

        <p>Entre também no grupo de WhatsApp para receber as informações em primeira mão.</p>
      
        <div className={styles.areaButtonW}>
        <Link to="https://chat.whatsapp.com/DJhIHFmSKn3LgU8m5O7r1O" target="_blank">
          <button className={styles.whatsappButton}>CLIQUE AQUI PARA ENTRAR NO GRUPO</button>
        </Link>
        </div>

        <p className={styles.finalMessage}>Fique de olho, março está chegando!</p>
      </div>
    </div>
  );
};

export default ConfirmationPage;

